import React from 'react';

import { Header, Spacer, Text } from '@kueski-dev/kueski-design-system';

import { CardContainer } from '../EmailVerification.styles';
import Confirmation from './confirmation.svg';

export const SuccessVerificationUI = () => (
  <CardContainer>
    <Confirmation />
    <Spacer $size="spacing06" />
    <Header $align="center" $format="Title/Large/Bold">
      ¡Correo verificado!
    </Header>
    <Spacer $size="spacing06" />
    <Text $align="center" $color="textSecondary" $format="Body/Large/Regular">
      Puedes cerrar esta pestaña y continuar lo que estabas haciendo.
    </Text>
  </CardContainer>
);
